import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, NgxSpinnerModule],
    template: `<router-outlet></router-outlet><p-toast></p-toast><ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-fall"></ngx-spinner>`
})
export class AppComponent {}
